(() => {
  const root = document.documentElement;
  const modal = document.getElementById('ss-request');
  if (!modal) return;

  const dialog = modal.querySelector('.ss-request__dialog');
  const closeEls = modal.querySelectorAll('[data-ss-request-close]');
  const form = modal.querySelector('#SSRequestForm');
  const status = modal.querySelector('.ss-request__status');

  let lastFocused = null;

  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'textarea:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');

  function setAria(open) {
    modal.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function lockScroll(lock) {
    if (lock) root.classList.add('ss-modal-lock');
    else root.classList.remove('ss-modal-lock');
  }

  function openModal() {
    if (modal.classList.contains('is-open')) return;
    lastFocused = document.activeElement;

    modal.classList.add('is-open');
    setAria(true);
    lockScroll(true);

    status.className = 'ss-request__status';
    status.textContent = '';

    // focus first input
    const first = modal.querySelector('input, textarea, button');
    if (first) first.focus();
  }

  function closeModal() {
    if (!modal.classList.contains('is-open')) return;

    modal.classList.remove('is-open', 'is-loading');
    setAria(false);
    lockScroll(false);

    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  // Global open hook
  function bindOpeners() {
    document.querySelectorAll('[data-ss-request]').forEach((el) => {
      if (el.__ssBound) return;
      el.__ssBound = true;
      el.addEventListener('click', (e) => {
        e.preventDefault();
        openModal();
      });
    });

    // Also support hash open
    document.querySelectorAll('a[href="#request-best-price"]').forEach((el) => {
      if (el.__ssBound) return;
      el.__ssBound = true;
      el.addEventListener('click', (e) => {
        e.preventDefault();
        openModal();
      });
    });
  }

  // Close hooks
  closeEls.forEach((el) => el.addEventListener('click', closeModal));
  document.addEventListener('keydown', (e) => {
    if (!modal.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeModal();
  });

  // Basic focus trap
  modal.addEventListener('keydown', (e) => {
    if (!modal.classList.contains('is-open')) return;
    if (e.key !== 'Tab') return;

    const focusables = dialog.querySelectorAll(focusableSelector);
    if (!focusables.length) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  // AJAX submit (Shopify contact form)
  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      status.className = 'ss-request__status';
      status.textContent = '';

      modal.classList.add('is-loading');

      try {
        const action = form.getAttribute('action') || '/contact';
        const fd = new FormData(form);

        const res = await fetch(action, {
          method: 'POST',
          body: fd,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        // Shopify contact form often returns HTML; treat 200/302 as success.
        if (res.ok) {
          status.classList.add('is-success');
          status.textContent = 'Thanks! Your request has been submitted.';
          form.reset();

          setTimeout(() => closeModal(), 900);
        } else {
          status.classList.add('is-error');
          status.textContent = 'Something went wrong. Please try again.';
        }
      } catch (err) {
        status.classList.add('is-error');
        status.textContent = 'Network error. Please try again.';
      } finally {
        modal.classList.remove('is-loading');
      }
    });
  }

  // Observe DOM changes so new buttons also work
  const mo = new MutationObserver(() => bindOpeners());
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Initial bind
  bindOpeners();

  // If landing with hash
  if (window.location.hash === '#request-best-price') openModal();
})();
